package com.hyperether.goodjob.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.snapshotFlow

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
expect object PersistStore {
    fun getInt(key: String, default: Int): Int
    fun putInt(key: String, value: Int)
}

@Composable
fun rememberPersistedIntState(key: String, default: Int): MutableState<Int> {
    val state = remember { mutableStateOf(PersistStore.getInt(key, default)) }
    LaunchedEffect(key) {
        snapshotFlow { state.value }.collect { PersistStore.putInt(key, it) }
    }
    return state
}